import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/services/notification.service';
import { merge, Observable, BehaviorSubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DataSource } from '@angular/cdk/collections';
import { MatSort, Sort } from '@angular/material/sort';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { UserService } from 'src/app/core/services/user.service';
import { MatSelect } from '@angular/material';
import { CommonService } from 'src/app/core/services/common.service';
import { Router } from '@angular/router';
import { ResponsiveService } from '../../../../../../core/services/responsive.service';
import { DepartmentService } from '../../../../../../core/services/department.service';
import { AddDepartmentComponent } from './add-department/add-department.component';
import { AutoDocumentTypeParentService } from 'src/app/core/services/auto-document-type-parent.service';
import { UpdateDepartmentComponent } from './update-department/update-department.component';
import { AssignRepresentativeComponent } from './assign-representative/assign-representative.component';
import { AddUserDepartmentComponent } from './add-user-department/add-user-department.component';
import { DepartmentDetailComponent } from './department-detail/department-detail.component';
import { ErrorCode } from 'src/app/core/constants/error-code';
import {TranslateService} from '@ngx-translate/core';
import {environment} from "../../../../../../../environments/environment";
import { EnvService } from 'src/app/core/services/env.service';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.scss']
})
export class DepartmentComponent implements OnInit, AfterViewInit, OnDestroy {

  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "stt", showXS: true, showSM: true, showMD: true},
    { def: "code", showXS: true, showSM: true, showMD: true },
    { def: "name", showXS: true, showSM: true, showMD: true },
    { def: "departmentType", showXS: true, showSM: true, showMD: true},
    { def: "fullName", showXS: false, showSM: true, showMD: false },
    { def: "description", showXS: false, showSM: true, showMD: false },
    { def: "status", showXS: false, showSM: true, showMD: false },
    { def: "action", showXS: true, showSM: true, showMD: true},
  ];

  dataSource: DigitalCertificateDataSource;

  digitalCertificate = new DigitalCertificate();
  paginate: Paginate;
  oldData = this.digitalCertificate;
  isFirstLoad = true;
  sortDirection = 'ASC';
  sortColumn = 'name';
  error = '';
  userType: any;
  checkFocus = false;
  // enterpriseId: string;
  sme_hub:any
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('typeCertificateSelect', { static: false }) typeCertificateSelect: MatSelect;
  @BlockUI() blockUI: NgBlockUI;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    private dialog: MatDialog,
    private message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private notificationService: NotificationService,
    private router: Router,
    private responsiveService: ResponsiveService,
    private departmentService: DepartmentService,
    public autoDocumentTypeParentData: AutoDocumentTypeParentService,
    private translateService: TranslateService,
    private env:EnvService
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.userType = localStorage.getItem('userType');
    this.sme_hub = env.sme_portal_url
  }
  ngOnInit() {
    // load data for first time
    this.loadDataForFirstTime();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
  }

  ngAfterViewInit(page: number = 0) {
    setTimeout(_ => document.getElementById('focusInput').focus());
    // register event for for sorting

    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if(this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }
    }
    // if (this.commonService.getIsLockedEnterprise()) {
      // this.displayedColumns = this.columnDefinitions
        // .filter(cd => (cd.def !== 'action' && cd.def !== 'status'))
        // .map(cd => cd.def);
    // }
  }

  /**
   * Open dialog add
   */
  get getPermisionSME(){
    if(localStorage.getItem('isFromSSO') =='true'){
      return true
    }
    return false
  }

  openDialogAdd() {
    if(this.getPermisionSME == true){
      window.open(this.sme_hub+'/admin/organization-management','_blank');
      return
  }
    const dialogRef = this.dialog.open(AddDepartmentComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '65%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100vw' : '90vw',
      // panelClass: 'scontract-overlay-dialog',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log(result)
      if (result) {
        this.onFilterDataAfterClose();
      }
    });
  }

  ngOnDestroy(): void {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  loadDataForFirstTime(page: number = 0, pageSize: number = 10) {

    this.dataSource = new DigitalCertificateDataSource();

    this.getSortDirection();

    this.departmentService.searchDepartment(
      this.getFilterCondition(page, pageSize))
      .subscribe(response => {
        if (this.responseHaveData(response)) {
          this.initPaginateToDisplay(response);
        }
        if (response.data && response.data.dataRow != null) {
          this.initDataToDisplay(response);
        }
      });
  }

  responseHaveData(response: any): boolean {
    return response.data != null &&
      response.data.currentPage != null &&
      response.data.pageSize != null &&
      response.data.totalRow != null &&
      response.data.totalRow != null;
  }

  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {
    this.blockUI.start('');
    this.getSortDirection();
    // console.log(this.oldData.nameOrCode);
    // console.log(this.oldData.status);
    this.departmentService.searchDepartment(
      this.getFilterCondition(page, pageSize, this.oldData.nameOrCode, this.oldData.status, this.oldData.departmentType))
      .subscribe(
        response => {
          // console.log(response);
          this.initPaginateToDisplay(response);
          this.initDataToDisplay(response);
          this.blockUI.stop()
        },
        error => {
          this.blockUI.stop()
        }
      );
  }

  getSortDirection() {

    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
  }

  getDepartmentType(departmentType: number) {
    if(departmentType == 1)
      return this.translateService.instant('enterprise_user_management.cbx_type.lbl_depart');
    if(departmentType == 2)
      return this.translateService.instant('enterprise_user_management.cbx_type.lbl_branch');
    if(departmentType == null)
      return "";
  }

  initPaginateToDisplay(rs: any) {
    this.paginate = {
      currentPage: rs.data.currentPage,
      pageSize: rs.data.pageSize,
      totalRow: rs.data.totalRow,
      totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
      totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
      no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
    };
  }

  initDataToDisplay(response: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;

    response.data.dataRow.forEach(parent => {
      parent['STT'] = stt++;
    });
    this.dataSource.setData(response.data.dataRow);
  }

  getFilterCondition(
    page: number, pageSize: number,
    nameOrCode: any = null, status: any = null, departmentType: any = null,
  ): any {

    let filterCondition = {};

    filterCondition = {
      id: 0,
      nameOrCode: nameOrCode,
      status: status,
      departmentType: departmentType,
      page,
      pageSize,
    };

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent

    let column = null;

    switch (sortColumn) {

      case 'taxCode':
        column = {
          taxCode: sortDirection
        };
        break;
      case 'phoneNumber':
        column = {
          phoneNumber: sortDirection
        };
        break;
      case 'typeCertificate':
        column = {
          typeCertificate: sortDirection
        };
        break;
      case 'effectiveDate':
        column = {
          effectiveDate: sortDirection
        };
        break;
      case 'activeDate':
        column = {
          activeDate: sortDirection
        };
        break;
      case 'expireDate':
        column = {
          expireDate: sortDirection
        };
        break;
    }

    filterCondition['sorts'] = column;
    // console.log(filterCondition);

    return filterCondition;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  viewUsersDepartment(department) {
    // this.departmentService.getUserDepartment(department.id)
    // console.log(department);
    this.departmentService.getRepresentativeByDepartmentId(department.idString).subscribe(res => {
      if (res.success) {
        department.representativeIdString = res.data;
      }
    })
    const dialogRef =  this.dialog.open(DepartmentDetailComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '65%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100vw' : '90vw',
      // panelClass: 'scontract-overlay-dialog',
      data: department
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
    });
  }

    editDepartment(department) {
      if(this.getPermisionSME == true){
       window.open(this.sme_hub+'/admin/organization-management','_blank');
       return
      }

     const dialogRef =  this.dialog.open(UpdateDepartmentComponent, {
        width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '45%',
        maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
        // panelClass: 'scontract-overlay-dialog',
        data: department
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
        }
        // this.onFilterData();
      });
    }

    // gán người đại diện phòng ban
    assignRepresentative(department) {
      // console.log('department', department)
      const dialogRef =  this.dialog.open(AssignRepresentativeComponent, {
         width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '45%',
         maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
        //  panelClass: 'scontract-overlay-dialog',
         data: department
       });
       dialogRef.afterClosed().subscribe(result => {
         if (result) {
           this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
         }
       });
     }

    //Thêm mới người dùng vào phòng ban
    //  addUserDepartment(department) {
    //   const dialogRef =  this.dialog.open(AddUserDepartmentComponent, {
    //      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '45%',
    //      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
    //     //  panelClass: 'scontract-overlay-dialog',
    //      data: department
    //    });
    //    dialogRef.afterClosed().subscribe(result => {
    //      if (result) {
    //       //  this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
    //      }
    //      this.onFilterData();
    //    });
    //  }


     delete(department) {
        const dialogRef = this.dialog.open(WarningComponent, {
          width: '500px',
          data: this.commonService.format(this.message.getMessage('messages.confirm_delete_department'), department.name)
        });
        dialogRef.afterClosed().subscribe(rs => {
          if (rs) {
            this.departmentService.deleteDepartment(department.idString).subscribe((res) => {
              console.log('res', res);
              if (res.success) {
                // console.log(res)
                if (res.data === 'user_exist') {
                  this.toastr.error(this.commonService.format(this.message.getMessage('messages.delete_department_error_user'), department.name));
                } else {
                  this.toastr.success(this.commonService.format(this.message.getMessage('messages.delete_department'), department.name));
                  if (this.paginate.totalRow % this.paginate.pageSize === 1) {
                    if (this.paginate.currentPage - 1 < 0) {
                      this.paginate.currentPage = 0;
                    } else {
                      this.paginate.currentPage = this.paginate.currentPage - 1;
                    }
                  }
                  this.onFilterData();
                }
              } else if (res.code === ErrorCode.DataNotfound){
                this.onFilterData();
                this.toastr.error(this.commonService.format(this.message.getMessage('messages.delete_department_error_not_found'), department.name));
              } else if (res.code === ErrorCode.ContactSystemAdmin){
                this.onFilterData();
                this.toastr.error(this.commonService.format(res.message));
              } else if(res.code === ErrorCode.ContractExist) {
                this.toastr.error(this.commonService.format(res.message));
              } else {
                this.onFilterData();
                this.toastr.error(this.commonService.format(this.message.getMessage('messages.delete_department_error_system'), department.name));
              }
            });
          }
        });
     }



    sortData(sort: Sort) {

      if (!sort.active || sort.direction === '') {
        return;
      }
      this.sortColumn = sort.active;
    }

    /**
     * Change status
     */
    onChangeDepartmentStatus(department, departmentStatus: boolean) {
      var s1 = departmentStatus ? '<strong>' + this.message.getMessage('enterprise-certificate_management.cbx_certificate_status.cbx_certificate_status_active') + '</strong>'
        : '<strong>' + this.message.getMessage('enterprise-certificate_management.cbx_certificate_status.cbx_certificate_status_inactive') + '</strong>';

      var s2 = !departmentStatus ? '<strong>' + this.message.getMessage('enterprise-certificate_management.cbx_certificate_status.cbx_certificate_status_active') + '</strong>'
        : '<strong>' + this.message.getMessage('enterprise-certificate_management.cbx_certificate_status.cbx_certificate_status_inactive') + '</strong>';

      const dialogRef = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.commonService.format(this.message.getMessage('messages.confirm_change_status_department'), s1, s2, department.name)
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (departmentStatus) {
            this.departmentService.lockDepartment(department.idString).subscribe((res) => {
              // console.log(' khoa', res);
              if (res.success) {
                this.toastr.success(this.message.getMessage('messages.update_department_status_success'));
                this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
              } else if (res.code === ErrorCode.DepartmentLockError){
                this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
                this.toastr.error(this.commonService.format(res.message));
              } else if (res.code === ErrorCode.DataNotfound) {
                this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
                this.toastr.error(this.message.getMessage('messages.update_department_status_entity_error'));
              } else {
                this.toastr.error(this.message.getMessage('messages.update_department_status_error'));
              }
            });
          } else {
            this.departmentService.unLockDepartment(department.idString).subscribe((res) => {
              console.log('mo khoa', res);
              if (res.success) {
                this.toastr.success(this.message.getMessage('messages.update_department_status_success'));
                this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
              }  else if (res.code === ErrorCode.DepartmentUnlockError){
                this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
                this.toastr.error(this.commonService.format(res.message));
              } else if (res.code === ErrorCode.DataNotfound) {
                this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
                this.toastr.error(this.message.getMessage('messages.update_department_status_entity_error'));
              } else {
                this.toastr.error(this.message.getMessage('messages.update_department_status_error'));
              }
            });
          }
        }
      });
    }

    /**
     * Filter data when close dialog
     */
    onFilterDataAfterClose() {
      if (this.paginate.totalRow % this.paginate.pageSize === 1) {
        if (this.paginate.currentPage - 1 < 0) {
          this.paginate.currentPage = 0;
        } else {
          this.paginate.currentPage = this.paginate.currentPage - 1;
        }
      }
      this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
    }

    /**
     * Navigate to page register OTP
     */
    registerOTP() {
      this.router.navigate(['/home-enterprise/otp-register/'], {
        queryParams: {
          page: this.paginate.currentPage,
          pageSize: this.paginate.pageSize,
        }
      });
    }

  }

  export class DigitalCertificate {
  nameOrCode: any;
  status: any = 'null';
  departmentType: any;
}

export class DigitalCertificateDataSource extends DataSource<DigitalCertificate> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DigitalCertificate[]>([]);

  constructor() {
    super();
  }


  setData(data: DigitalCertificate[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DigitalCertificate[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];

}
